import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './preparation-item-report.controller';
import directive from './preparation-item-report.directive';


export default angular.module('app.components.advisory.auditTrail.preparationItemReport', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amPreparationItemReport', directive)
  .controller('PreparationItemReportController', controller)
  .name;

console.log('app.components.advisory.auditTrail.preparationItemReport created');
